import { useState } from 'react';
import { connect } from 'react-redux';
import { Alert, Loader } from '../..';
import { IDataStorage } from '../../../core';
import { FxTranslate } from '../../../core/translate';
import PasajeroForm from '../../../pages/admin/config/pasajero/form';
import API from '../../../services/api';
import { IPasajero } from '../../../services/api/entity/model/IPasajero';
import Service from '../../../services/common/services/formservice';
import { CardHelper, ICardEdit } from '../../../services/operaciones/model/ICardEdit';
import { Button, Column, DataTable, Dialog } from '../../prime';
import { Secciones } from '../index.service';
import styles from './index.module.scss';
import Question from '../../question';

const format = (window as any).format;
const CloseCard = (forceRefresh?: boolean) => (window as any).CloseCard(forceRefresh);

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  data?: ICardEdit | null | undefined;

  onUpdateFields: (updates: { field: string, value: any }[]) => void;
}

function CardSeccionPasajeros({ storage, t,
  data,
  onUpdateFields,
} : IProps) {
  const [ pasajeroDialog, setPasajeroDialog ] = useState<{ saving?: boolean, id?: number } |undefined>(undefined);
  const [ pasajeroForm, setPasajeroForm ] = useState<Service<IPasajero>|undefined>(undefined);
  const [ questionReemitir, setQuestionReemitir ] = useState<undefined | 'ask' | 'procesing'>(undefined);

  const onPasajeroSave = (service: Service<IPasajero>|undefined) => {
    const dto = service?.getEntity();
    if (!dto?.success || !dto.data) return;
    setPasajeroDialog({ id: pasajeroDialog?.id, saving: true });
    API.OperacionesController().Pasajero().upsert(dto.data!).then(upd => {
      Alert.reponse(upd);
      if (upd.success && !!data?.operacionpasajeros && !!dto.data) {
        Alert.info(t("Seccion.Pasajero.Dialog.Pasajero.Guardar.Success.Titulo"), t("Seccion.Pasajero.Dialog.Pasajero.Guardar.Success.Msg", { id: dto.data.nombre }));
        
        const cambio = data.operacionpasajeros.find(p => p.paxindex === dto.data?.paxIndex) as any;
        cambio.nombre = dto.data.nombre;
        cambio.apellido = dto.data.apellido;
        cambio.documento = dto.data.documento;
        cambio.nacimiento = dto.data.nacimiento;
        onUpdateFields([ 
          { field: "random", value: Math.random() },
          { field: "operacionpasajeros", value: [...data.operacionpasajeros] },
        ]);

        if (CardHelper.mustAskForReemitir(data, ['force']))
          setQuestionReemitir('ask');
      }
    })
    .catch(err => Alert.error(t("Seccion.Pasajero.Dialog.Pasajero.Guardar.Error.Titulo"), err))
    .finally(() => {
      setPasajeroDialog(undefined);
    })
  }


  return <div className={styles["card-seccion-content"]}>
    <div className={styles["card-seccion-title"]}>{t(`Menu.${Secciones.Pasajeros}`)}</div>
    
    <div className='p-grid'>
      <div className='p-col-12 p-lg-12 p-p-2'>
        <div className="datatable-responsive-demo">
          <DataTable 
            value={data?.operacionpasajeros?.sort((a,b) => (a.orden??a.paxindex??0) > (b.orden??b.paxindex??0) ? 1 : -1).map(p => p.pasajero ?? p) ?? []}
            className="p-datatable-responsive-demo"
          >
            <Column field='nombre' header={t("Seccion.Field.operacionpasajeros.pasajero.nombre")} />
            <Column field='apellido' header={t("Seccion.Field.operacionpasajeros.pasajero.apellido")} />
            <Column field='documento' header={t("Seccion.Field.operacionpasajeros.pasajero.documento")} />
            <Column 
              header={t("Seccion.Field.operacionpasajeros.pasajero.nacimiento")} 
              body={row => <>{format(row?.fechanacimiento ?? row?.nacimiento, "dd/MM/yyyy")}</>}
            />
            <Column 
              style={{ width: 40 }} 
              body={(row,col) => <div>
                <Button 
                  icon='pi pi-pencil' 
                  disabled={!CardHelper.allowEdit(data, 'force')}
                  className='p-button-rounded p-button-outlined p-button-sm'
                  style={{ width: 28, height: 28, padding: 0 }}
                  onClick={() => setPasajeroDialog({ id: row.id })}
                />
              </div>} />
          </DataTable>
        </div>
        
        <Dialog 
          visible={!!pasajeroDialog} 
          onHide={() => setPasajeroDialog(undefined)} 
          header={t("Seccion.Pasajero.Dialog.Pasajero.Title")} 
          style={{ width: 600, maxWidth: '100%' }} 
          footer={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
            <Loader loading={pasajeroDialog?.saving}>
              <Button icon="pi pi-times" label={t("Seccion.Pasajero.Dialog.Pasajero.Cerrar")} className="p-button-secondary" onClick={() => setPasajeroDialog(undefined)} tooltip={t("Seccion.Pasajero.Dialog.Pasajero.Cerrar.Tooltip")} tooltipOptions={{ position: 'top' }} style={{ marginLeft: 10 }} />
              <Button icon="pi pi-save" disabled={!CardHelper.allowEdit(data, 'force')} label={t("Seccion.Pasajero.Dialog.Pasajero.Guardar")} className="p-button-primary" tooltip={t("Seccion.Pasajero.Dialog.Pasajero.Guardar.Tooltip")} tooltipOptions={{ position: 'top' }} onClick={() => onPasajeroSave(pasajeroForm)} />
            </Loader>
          </div>}
        >
          <Loader loading={pasajeroDialog?.saving}>
            <PasajeroForm id={pasajeroDialog?.id} refService={f => setPasajeroForm(f)} />
          </Loader>
        </Dialog>
      </div>
    </div>
    <Question
      text={t("Question.ReEmitirVoucher.Text")}
      title={t("Question.ReEmitirVoucher.Title")}
      ok_text={t("Question.ReEmitirVoucher.Ok")}
      cancel_text={t("Question.ReEmitirVoucher.Cancel")}
      visible={!!questionReemitir}
      working={questionReemitir === 'procesing'}
      ok={() => {
        setQuestionReemitir('procesing');
        CardHelper.reemitirIfAllow(data, ['force']).then(res => {
          if (!res.success) {
            setQuestionReemitir(undefined);
            return Alert.reponse(res);
          }
          setQuestionReemitir(undefined);
          CloseCard(true);
        }).catch(ex => Alert.exception(t, ex))
      }}
      onClose={() => setQuestionReemitir(undefined)}
    />
  </div>;
}

export default connect((s:any) => ({ storage:s.main }))(CardSeccionPasajeros);
